import React from 'react';
import PropTypes from 'prop-types';
import Button from '@medflex/components/stories/Button';
import InfoBanner, { KINDS } from '@medflex/components/stories/InfoBanner';
import useModal from '../../hooks/useModal';

const { useTranslation } = require('react-i18next');

const SessionLimitBanner = ({ active, limit, count }) => {
  const { t } = useTranslation('global', { keyPrefix: 'infoBanner' });
  const { open } = useModal();
  return (
    <InfoBanner kind={KINDS.SIGNAL} className="mb-8 p-5 w-full">
      {active ? (
        <>
          {t('active', {
            allowHtml: true,
            count: limit - count,
          })}
          <Button kind="link" onClick={() => open({ modal: 'featureUpgradeSessionMeeting' })}>
            {t('upgrade')}
          </Button>
        </>
      ) : (
        <>
          {t('used_up', { allowHtml: true })}
          <Button kind="link" onClick={() => open({ modal: 'featureUpgradeSessionMeeting' })}>
            {t('upgrade')}
          </Button>
        </>
      )}
    </InfoBanner>
  );
};

SessionLimitBanner.propTypes = {
  active: PropTypes.bool,
  limit: PropTypes.number,
  count: PropTypes.number,
};

export default SessionLimitBanner;
